module.exports = __webpack_public_path__ + "static/media/5 Minutes  24Feb2022 with AERCUs.75901124.pdf";